// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__8ty6h","tab--active":"Tab_tab--active__KsGdZ"};